import app from '../../scripts/app';
import template from './estimated-price.jade';
import estimatedPriceCtrl from './estimated-price.controller';

app.directive('cianAfEstimatedPrice', () => {
  return {
    template,
    scope: {},
    bindToController: {},
    controller: estimatedPriceCtrl,
    controllerAs: 'estimatedPriceCtrl',
  };
});
